
import type { CrudListData } from '../../mixins/crud-list.mixin'
import type { DataTableOption } from '../../models'
import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'
import { defineComponent } from 'vue'
import CrudList from '../../components/crud/crud-list.component.vue'
import DataTable from '../../components/crud/data-table.component.vue'
import { AlignEnum, FeatureIdEnum } from '../../enums'
import { CrudListMixin } from '../../mixins/crud-list.mixin'
import { ROUTER_CONSTS } from '../../router/router.consts'

export default defineComponent({
  name: 'BlacklistList',
  components: {
    CrudList,
    DataTable,
  },
  mixins: [CrudListMixin],
  data(): Partial<CrudListData> {
    const messages = this.$epb.messages.tools.blacklist
    return {
      dataType: ActionTypeEnum.BLACKLIST,
      routes: {
        create: ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].create,
        update: ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].update,
      },
      columns: [
        {
          id: 'lang',
          text: messages.fields.lang.label,
          sortable: true,
        },
        {
          id: 'terms',
          text: messages.fields.terms.label,
          width: '200%',
          unwrapText: true,
          copyToClipboard: true,
        },
        {
          id: 'meta.updateDate',
          text: messages.fields.updateDate.label,
          sortable: true,
        },
        {
          id: 'enabled',
          text: messages.fields.enabled.label,
          sortable: true,
        },
        {
          id: 'options',
          width: '44px',
          align: AlignEnum.CENTER,
        },
      ],
      messages,
    }
  },
  methods: {
    onOptionsClick(option: DataTableOption, dataItem) {
      this.onOptionClick(option, dataItem, this.$refs.crudListRef)
    },
  },
})
